module.exports = "<promotions-page></promotions-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/promotions.html
// module id = 1543
// module chunks = 0